import { Divider, Modal } from "antd";
import "./sheetOrder.css";
import { useEffect, useState } from "react";
import Util from "../../Util";
import moment from "moment";
import Spinner from "../../Components/SheetCard/Spinner";

const SheetOrdersModal = (props) => {
  const [sheets, setSheets] = useState();
  const [totalPrice, setTotalPrice] = useState(0);
  const [page, setPage] = useState(0);
  const [loading, setLoading] = useState(false);
  const [isStopFetch, setIsStopFetch] = useState(false);

  useEffect(() => {
    if (props.open) getOrders();
    console.log(props.row);
  }, [props.open]);

  const getOrders = async () => {
    try {
      setLoading(true);
      const data = await Util.sendPost("/api/seller/getSellSheetsByOrder", {
        id: props.row?.orig._id,
        page,
        pageLimit: 50,
        store: props.row?.orig.store,
      });

      if (data.data?.sheets) {
        setPage((prev) => prev + 1);
        setSheets((prev) => {
          if ((data?.data?.sheets ?? []).length <= 0) {
            setIsStopFetch(true);
          }
          return (prev ?? []).concat(data.data?.sheets);
        });
        setTotalPrice(data.data.totalPrice);
      }
    } catch {
      props.onCancel();
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={props.open}
      footer={null}
      centered
      height={760}
      width={1080}
      className="sheet-orders-modal"
      wrapClassName="sheet-orders-modal-wrap"
      destroyOnClose
      onCancel={() => {
        props.onCancel();
      }}
      afterClose={() => {
        setSheets(undefined);
        setPage(0);
        setLoading(false);
        setIsStopFetch(false);
        setTotalPrice(0);
      }}
    >
      <div className="sheet-orders-body">
        <h1>รายการชีทที่ขาย ({props.row?.monthString ?? "-"})</h1>
        <table>
          <thead>
            <tr>
              <th>วันที่สั่งซื้อ</th>
              <th>รายละเอียดชีท</th>
              <th></th>
              <th className="align-center">ราคา (บาท)</th>
              <th className="align-center">ส่วนแบ่งรายได้ 60% (บาท)</th>
            </tr>
          </thead>
          <div
            className="tbody-container"
            onScroll={(e) => {
              if (Util.endScroll(e) && !isStopFetch && !loading) {
                getOrders();
              }
            }}
          >
            {loading ? (
              <div className="spinner-container">
                <Spinner color={"#ffcd09"} size={40} />
              </div>
            ) : null}
            <tbody>
              {sheets?.map((el) => (
                <tr key={el.created + "" + el.name}>
                  <td>
                    {moment.unix(el.created).format("DD/MM/YY")} <br />{" "}
                    {moment.unix(el.created).format("HH:mm:ss")}
                  </td>
                  <td>
                    <p className="number-color">
                      {el?.name?.split(" ")[0] !== undefined &&
                      el?.name?.split(" ")[0].trim() !== ""
                        ? el?.name?.split(" ")[0]
                        : "-"}
                    </p>
                  </td>
                  <td>{el?.name?.split(" ")[1] ?? "-"}</td>
                  <td>
                    <p className="number-color">
                      {el?.price?.toFixed(2) ?? "-"}
                    </p>
                  </td>
                  <td>
                    <p className="number-color">
                      {el?.price !== undefined
                        ? (el?.price * 0.6).toFixed(2)
                        : "-"}
                    </p>
                  </td>
                </tr>
              ))}
            </tbody>
          </div>
        </table>

        <Divider />

        <div className="summary-section">
          <div className="summary-row">
            <p className="light-text">ยอดขายรวม</p>{" "}
            <p className="total-sales-text">{totalPrice?.toFixed(2)}</p>
          </div>
          <div className="summary-row">
            <p className="light-text">
              ส่วนแบ่งรายได้ 60% (ยอดก่อนหักภาษี ณ ที่จ่าย
              และค่าธรรมเนียมการโอน)
            </p>{" "}
            <p className="revenue-share-text">
              {totalPrice !== undefined ? (totalPrice * 0.6)?.toFixed(2) : "0"}
            </p>
          </div>
          {/* <div className="summary-row">
            <p className="light-text">ภาษีหัก ณ ที่จ่าย</p>{" "}
            <p className="light-text">
              {props?.row?.witholding !== undefined
                ? props?.row?.witholding
                : "0.00"}
            </p>
          </div> */}
        </div>

        {/* <Divider /> */}

        {/* <div className="summary-section">
          <div className="summary-row">
            <p className="light-text">ยอดจ่ายออกสุทธิ</p>{" "}
            <p>{props?.row?.totalPay ? props?.row?.totalPay : "0.00"}</p>
          </div>
        </div> */}
      </div>
    </Modal>
  );
};

export default SheetOrdersModal;
